import { FC } from 'react'
import { ButtonType, IconPaths, IconSize, KTSVG } from '../../../_metronic/helpers'
import styles from './styles/ButtonIcon.module.css'

/** Variantes com contorno; sem variant, o visual vem das classes em `className`. */
export type ButtonIconVariant = 'secondary-outline-danger'

const VARIANT_CLASS: Record<ButtonIconVariant, string> = {
  // Neutro em repouso, vermelho no hover/foco (ex.: remover item de uma lista).
  'secondary-outline-danger': styles.secondaryOutlineDanger,
}

type IButtonIcon = {
  onClick?: () => void
  icon?: IconPaths | null
  type?: ButtonType
  className?: string
  color?: string
  iconSize?: IconSize
  style?: React.CSSProperties | undefined
  disabled?: boolean
  ariaLabel?: string
  variant?: ButtonIconVariant
  /** Dica ao passar o mouse; o nome acessível continua sendo o `ariaLabel`. */
  title?: string
}

export const ButtonIcon: FC<IButtonIcon> = ({
  onClick,
  icon = null,
  type = ButtonType.Button,
  className = '',
  color,
  iconSize = IconSize.ExtraSmall,
  style,
  disabled,
  ariaLabel,
  variant,
  title,
}) => {
  const isDelete = icon === IconPaths.Trash && !variant
  return (
    <button
      type={type}
      className={`btn ${
        variant
          ? `btn-outline d-inline-flex align-items-center justify-content-center ${VARIANT_CLASS[variant]}`
          : ''
      } ${className} ${isDelete ? 'btn-active-light-danger' : ''}`}
      title={title}
      onClick={onClick}
      style={style}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      {icon ? <KTSVG path={icon} size={iconSize} color={color} className='m-0' /> : null}
    </button>
  )
}
